import axiosInstance from "../../../api/axiosConfig";

export const getOrders = (params: any) => {
  return axiosInstance.get("/admin/orders", {
    params: params,
  });
};

export const downloadOrderExcel = (orderId: string) => {
  return axiosInstance.get(`/admin/orders/download/excel`, {
    params: {
      orderId: orderId,
    },
  });
};

export const downloadOrderXML = (orderId: string) => {
  return axiosInstance.get(`/admin/orders/download/xml`, {
    params: {
      orderId: orderId,
    },
  });
};
